import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Compass, Wallet, BrainCircuit } from 'lucide-react';
const pains = [{
  icon: Compass,
  text: 'No sabés por dónde empezar',
  description: 'La información en internet es abrumadora y contradictoria.'
}, {
  icon: XCircle,
  text: 'Probaste ideas pero no funcionaron',
  description: 'Invertiste tiempo y esfuerzo sin ver resultados reales.'
}, {
  icon: Wallet,
  text: 'Pensás que necesitás experiencia o dinero',
  description: 'Creés que hace falta un gran capital inicial para arrancar.'
}, {
  icon: BrainCircuit,
  text: 'Sentís que emprender es complicado',
  description: 'Te frena el miedo a la burocracia y a no saber vender.'
}];
export function PainSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-y border-white/5 relative overflow-hidden" data-id="element-131">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-warmBrown/20 blur-[100px] rounded-full pointer-events-none" data-id="element-132" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-134">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-balance" data-id="element-135">
            El 90% nunca genera{' '}
            <span className="text-cream-muted italic" data-id="element-136">ingresos extra…</span>
          </h2>
          <p className="text-xl text-cream-muted max-w-2xl mx-auto" data-id="element-137">
            no porque no pueda, sino porque nunca convierte algo simple en
            dinero.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 lg:gap-8" data-id="element-138">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-charcoal/50 border border-white/5 p-8 rounded-2xl flex gap-6 items-start group hover:bg-warmBrown/30 transition-colors duration-300" data-id="element-139">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-charcoal flex items-center justify-center border border-white/10 group-hover:border-gold/30 transition-colors" data-id="element-140">
                <pain.icon className="w-6 h-6 text-cream-muted group-hover:text-gold transition-colors" data-id="element-141" />
              </div>
              <div data-id="element-142">
                <h3 className="text-lg font-semibold mb-2 text-cream" data-id="element-143">
                  {pain.text}
                </h3>
                <p className="text-cream-muted/70 text-sm leading-relaxed" data-id="element-144">
                  {pain.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}